// 操作日志「操作对象」类型字典
// 与后端 AdministratorOperationLogService::TARGET_TYPE_LABELS 保持一致。
// 背景：target_id 是一列多指向（同一个 ID 列按 action 指向不同表），
// 所以对象必须按类型显示不同内容、跳不同页面，不能一律当管理员解析。
// linkKey 是 RouteConfig 的键名，由页面自行解析成路由（避免枚举文件依赖路由表造成循环引用）。
export const operationTargetTypes = {
  administrator: { value: 'administrator', name: '管理员', tagType: '', linkKey: 'administratorEdit' },
  invite: { value: 'invite', name: '入职邀请', tagType: 'warning', linkKey: 'administratorInviteDetail' },
  onboard_apply: { value: 'onboard_apply', name: '入职申请', tagType: 'info', linkKey: 'administratorOnboardApplyDetail' },
  role_merge: { value: 'role_merge', name: '任职记录', tagType: 'success', linkKey: 'administratorSalaryEdit' },
};

export const operationTargetTypeOptions = Object.values(operationTargetTypes);

export function findOperationTargetType(value) {
  return operationTargetTypes[value] || { value: value || '', name: '未知对象', tagType: 'info', linkKey: '' };
}

// 变更明细的形态：后端 buildChanges 返回 kind
// diff（前后是同一对象）：update = 旧值→新值；create/delete = 该字段只在新/旧快照里出现；
// result（前后不是同一对象，如入职审核通过：前=申请表、后=新建账号）：
//   source = 原记录里的值，result = 本次操作写入的值；两者都不画箭头，详情页按这两类分组列出。
export const operationChangeKinds = {
  create: { value: 'create', name: '新增', tagType: 'success' },
  update: { value: 'update', name: '修改', tagType: '' },
  delete: { value: 'delete', name: '移除', tagType: 'danger' },
  source: { value: 'source', name: '原记录', tagType: 'info' },
  result: { value: 'result', name: '本次写入', tagType: 'warning' },
};

export function findOperationChangeKind(value) {
  return operationChangeKinds[value] || { value: value || '', name: '变更', tagType: 'info' };
}
